(function () {
  var DISCLAIMER =
    'Die virtuelle Anprobe dient zur Orientierung. Farbe, Form und Details können vom tatsächlichen Produkt abweichen.';

  var SVG_INFO =
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  // --- 1. Page note: insert AFTER the FittingBox app-block div ---
  // FittingBox renders the button with display:none initially, then
  // check-frame-availability.js makes it visible for supported products.
  // We watch for that style change and insert the note once it's visible.

  var btnObserver = null;

  function tryAddPageNote() {
    if (document.querySelector('.bd-vto-page-note')) return;

    var btn = document.getElementById('fbx_product_button_embed');
    if (!btn) return;

    // Only show note when the button is actually visible
    var display = btn.style.display || window.getComputedStyle(btn).display;
    if (!display || display === 'none') return;

    if (btnObserver) {
      btnObserver.disconnect();
      btnObserver = null;
    }

    var note = document.createElement('p');
    note.className = 'bd-vto-page-note';
    note.innerHTML = SVG_INFO + ' ' + DISCLAIMER;

    // Insert after the entire shopify-app-block div, not inside it
    var blockDiv = btn.closest('.shopify-app-block') || btn.parentElement;
    blockDiv.insertAdjacentElement('afterend', note);
  }

  function initPageNote() {
    var btn = document.getElementById('fbx_product_button_embed');
    if (!btn) return;

    // Already visible?
    tryAddPageNote();

    // Watch for FittingBox making the button visible (style attribute change)
    btnObserver = new MutationObserver(tryAddPageNote);
    btnObserver.observe(btn, { attributes: true, attributeFilter: ['style', 'class'] });
  }

  // --- 2. Modal disclaimer: inject above FittingBox iframe when modal opens ---

  var SVG_INFO_LG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  function buildModalBanner() {
    var banner = document.createElement('div');
    banner.className = 'bd-vto-modal-disclaimer';
    banner.setAttribute('role', 'note');
    banner.innerHTML = SVG_INFO_LG + ' ' + DISCLAIMER;
    return banner;
  }

  function tryInjectModalBanner(node) {
    if (node.dataset && node.dataset.bdDisclaimer) return;

    var iframes =
      node.tagName === 'IFRAME' ? [node] : Array.from(node.querySelectorAll('iframe'));

    iframes.forEach(function (iframe) {
      var src = iframe.src || iframe.dataset.src || '';
      if (!src.includes('fittingbox') && !src.includes('glasseson')) return;

      var container = iframe.parentElement;
      while (container && container !== document.body) {
        var z = parseInt(window.getComputedStyle(container).zIndex, 10);
        if (z > 50 || /modal|overlay|popup|fbox|fitting/i.test(container.className)) break;
        container = container.parentElement;
      }
      if (!container || container === document.body) container = iframe.parentElement;
      if (container.dataset.bdDisclaimer) return;

      container.dataset.bdDisclaimer = '1';
      container.style.display = container.style.display || 'flex';
      container.style.flexDirection = 'column';
      container.prepend(buildModalBanner());
    });
  }

  var domObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        tryInjectModalBanner(node);
      });
    });
  });

  function init() {
    initPageNote();
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
